import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 'auto',
    padding: theme.spacing(4, 2),
    borderTop: `solid 1px ${fade(theme.palette.primary.main, 0.2)}`,
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      // justifyContent: 'space-between',
      padding: theme.spacing(3, 4),
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(3, 7),
    },
  },
  select: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      minWidth: theme.spacing(30),
      marginBottom: 0,
    },
    [theme.breakpoints.up('lg')]: {
      width: theme.spacing(41),
    },
  },
  logo: {
    opacity: 0.6,
    order: 3,
    [theme.breakpoints.up('md')]: {
      order: 2,
    },
  },
  form: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '33%',
      marginRight: 'auto',
    },
    [theme.breakpoints.up('lg')]: {
      width: 'calc(50% - 40px)',
    },
  },
  links: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      width: '33%',
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: 0,
      order: 3,
      marginLeft: 'auto',
    },
    [theme.breakpoints.up('lg')]: {
      width: 'calc(50% - 40px)',
    },
  },
  link: {
    marginLeft: theme.spacing(6),
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(7),
    },
  },
}))

export default useStyles
